import { motion } from "framer-motion";
import { useLanguage } from "@/contexts/LanguageContext";
import { OptimizedPicture } from "@/components/OptimizedPicture";

const galleryImages = [
  {
    src: "/lovable-uploads/5e7eb691-6a44-4a9f-a3fd-6468e36f1e3c.png",
    alt: "Students engaged in collaborative learning"
  },
  {
    src: "/lovable-uploads/74fedc45-0a0c-47d1-97b1-e60dfde6624c.png",
    alt: "Children exploring nature"
  },
  {
    src: "/lovable-uploads/bosque-trepando-tronco.png",
    alt: "Children climbing a fallen tree trunk in the forest"
  },
  {
    src: "/lovable-uploads/67e510e0-509a-4b06-a27e-0d72e25c705e.png",
    alt: "Student working on Montessori materials"
  },
  {
    src: "/lovable-uploads/020e548d-6268-44b9-afa0-73e8bc8c1963.png",
    alt: "Children working with Montessori materials"
  },
  {
    src: "/lovable-uploads/arbol-escala-cuerda.png",
    alt: "Children climbing a big tree with a rope ladder"
  }
];

export const Gallery = () => {
  const { translations } = useLanguage();
  const t = translations?.gallery;

  if (!t) return null;

  return (
    <section className="py-20 px-4 bg-background">
      <div className="container mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="section-title">{t.title}</h2>
          <p className="section-subtitle">{t.subtitle}</p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-4">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
            className="md:col-span-8 md:row-span-2"
          >
            <div className="relative aspect-[4/3] md:aspect-[16/10] rounded-lg overflow-hidden shadow-lg group">
              <OptimizedPicture
                src={galleryImages[0].src}
                alt={galleryImages[0].alt}
                loading="lazy"
                decoding="async"
                width={622}
                height={415}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
            </div>
          </motion.div>

          {galleryImages.slice(1).map((image, index) => (
            <motion.div
              key={image.src}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: (index + 1) * 0.1 }}
              viewport={{ once: true }}
              className="md:col-span-4"
            >
              <div className="relative aspect-[4/3] rounded-lg overflow-hidden shadow-md group">
                <OptimizedPicture
                  src={image.src}
                  alt={image.alt}
                  loading="lazy"
                  decoding="async"
                  width={400}
                  height={300}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
